var map = {
	"./icon-facebook.svg": 56243,
	"./icon-google-plus.svg": 42739,
	"./icon-instagram3.svg": 50592,
	"./icon-linkedin.svg": 59781,
	"./icon-reddit3.svg": 8342,
	"./icon-telegram.svg": 66058,
	"./icon-twitter.svg": 42396,
	"./icon-wechat.svg": 48589,
	"./icon-weibo.svg": 78737,
	"./icon-whatsapp3.svg": 34708,
	"./icon-youtube.svg": 29730,
	"./icon-youtube3.svg": 52733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56481;